'use strict';

export default class Tabs {
  constructor() {

    $('ul.tabs__nav li').on('click keydown',function(){
    	var tab_id = $(this).attr('data-tab');

    	$('ul.tabs__nav li').removeClass('active');
    	$('.tab__content').removeClass('active');

    	$(this).addClass('active');
    	$('#'+tab_id).addClass('active');

    })

  }
}